import { format, register } from 'timeago.js'
import id from 'date-fns/locale/id'
import { format as formatFns } from 'date-fns'

import { roundWithPrecision } from 'utils/number'

import type { TDate } from 'timeago.js'

export const locale = 'id'

register(
  locale,
  (_number: number, index: number, totalSec: number): [string, string] => {
    const translations = [
      ['baru saja', 'sebentar'],
      ['%s detik lalu', 'dalam %s detik'],
      ['1 menit lalu', 'dalam 1 menit'],
      ['%s menit lalu', 'dalam %s menit'],
      ['1 jam lalu', 'dalam 1 jam'],
      ['%s jam lalu', 'dalam %s jam'],
      ['1 hari lalu', 'dalam 1 hari'],
      ['%s hari lalu', 'dalam %s hari'],
      ['1 minggu lalu', 'dalam 1 minggu'],
      ['%s minggu lalu', 'dalam %s minggu'],
      ['1 bulan lalu', 'dalam 1 bulan'],
      ['%s bulan lalu', 'dalam %s bulan'],
      ['1 tahun lalu', 'dalam 1 tahun'],
      ['%s tahun lalu', 'dalam %s tahun'],
    ]
    const translation = translations[index] as [string, string]
    if (translation[0].includes('minggu')) {
      const dayInSec = 86400
      const days = Math.ceil(totalSec / dayInSec)
      return [`${days} hari lalu`, `dalam ${days} hari`]
    }
    return translation
  }
)

export const months = [
  'Januari',
  'Februari',
  'Maret',
  'April',
  'Mei',
  'Juni',
  'Juli',
  'Agustus',
  'September',
  'Oktober',
  'November',
  'Desember',
]

export function humanizeDate(timestamp: string): string {
  const dateObj = new Date(timestamp)
  const date = dateObj.getDate()
  const month = dateObj.getMonth()
  const year = dateObj.getFullYear()
  const hour =
    dateObj.getHours() > 9 ? dateObj.getHours() : '0' + dateObj.getHours()
  const minute =
    dateObj.getMinutes() > 9 ? dateObj.getMinutes() : '0' + dateObj.getMinutes()

  return `${date} ${months[month]} ${year}, ${hour}:${minute}`
}

export function youtubeDurationToSeconds(duration: string): number {
  // https://developers.google.com/youtube/v3/docs/videos#contentDetails.duration

  let hours = 0
  let minutes = 0
  let seconds = 0

  duration = duration.replace('PT', '')

  if (duration.indexOf('H') > -1) {
    const hoursSplit = duration.split('H')
    hours = parseInt(hoursSplit[0])
    duration = hoursSplit[1]
  }

  if (duration.indexOf('M') > -1) {
    const minutesSplit = duration.split('M')
    minutes = parseInt(minutesSplit[0])
    duration = minutesSplit[1]
  }

  if (duration.indexOf('S') > -1) {
    const secondsSplit = duration.split('S')
    seconds = parseInt(secondsSplit[0])
  }

  return hours * 3600 + minutes * 60 + seconds
}

export function youtubeDurationToHms(duration: string): string {
  const durationInSeconds = youtubeDurationToSeconds(duration)
  const hours = Math.floor(durationInSeconds / 3600)
  const minutes = Math.floor((durationInSeconds % 3600) / 60)
  const seconds = Math.floor((durationInSeconds % 3600) % 60)

  const hoursDisplay = hours > 0 ? String(hours).padStart(2, '0') + ':' : ''
  const minutesDisplay = String(minutes).padStart(2, '0') + ':'
  const secondsDisplay = String(seconds).padStart(2, '0')

  return hoursDisplay + minutesDisplay + secondsDisplay
}

export function timeAgo(datetime: TDate): string {
  return format(datetime, locale)
}

export function minuteToHour(minutes: number): string {
  if (minutes < 60) {
    return `${minutes} menit`
  }
  return `${roundWithPrecision(minutes / 60, 1)} jam`
}

export function isoStringToDateInputTypeFormat(isoDateString: string) {
  const date = new Date(isoDateString)
  let year = date.getFullYear()
  let month = date.getMonth() + 1
  let dt = date.getDate()
  let sday = dt.toString()
  let smonth = month.toString()

  if (dt < 10) {
    sday = '0' + dt.toString()
  }
  if (month < 10) {
    smonth = '0' + month.toString()
  }
  return year.toString() + '-' + smonth + '-' + sday
}

export function getTimestampForGTag() {
  let date = new Date()
  date = new Date(date.getTime() - 3000000)
  return (
    date.getFullYear().toString() +
    '-' +
    ((date.getMonth() + 1).toString().length == 2
      ? (date.getMonth() + 1).toString()
      : '0' + (date.getMonth() + 1).toString()) +
    '-' +
    (date.getDate().toString().length == 2
      ? date.getDate().toString()
      : '0' + date.getDate().toString()) +
    ' ' +
    (date.getHours().toString().length == 2
      ? date.getHours().toString()
      : '0' + date.getHours().toString()) +
    ':' +
    (((date.getMinutes() / 5) * 5).toString().length == 2
      ? ((date.getMinutes() / 5) * 5).toString()
      : '0' + ((date.getMinutes() / 5) * 5).toString()) +
    ':00'
  )
}

export function formatDate(
  datetime: Date | string,
  formatString = 'dd MMMM yyyy'
): string {
  return formatFns(new Date(datetime), formatString, { locale: id })
}
